import { translate } from '@portal/services/i18n';

export enum PaymentStatus {
  PROCESSING = 1,
  EXECUTED = 2,
  WAITING_APPROVAL = 3,
  PORTABILITY_EXECUTED = 4,
  REPROVED = 5,
  APPROVED_WITH_ERROR = 6,
  SCHEDULED = 7,
}

export const PaymentStatusArray = [
  {
    value: PaymentStatus.PROCESSING,
    name: translate('PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.STATUS.PROCESSING'),
  },
  {
    value: PaymentStatus.EXECUTED,
    name: translate('PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.STATUS.EXECUTED'),
  },
  {
    value: PaymentStatus.WAITING_APPROVAL,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.STATUS.WAITING_APPROVAL'
    ),
  },
  {
    value: PaymentStatus.PORTABILITY_EXECUTED,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.STATUS.PORTABILITY_EXECUTED'
    ),
  },
  {
    value: PaymentStatus.REPROVED,
    name: translate('PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.STATUS.REPROVED'),
  },
  {
    value: PaymentStatus.APPROVED_WITH_ERROR,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.STATUS.APPROVED_WITH_ERROR'
    ),
  },
  {
    value: PaymentStatus.SCHEDULED,
    name: translate('PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.STATUS.SCHEDULED'),
  },
];

export const getPaymentStatus = (id: number) => {
  return PaymentStatusArray.find((o) => o.value === id)?.name;
};
